var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrbitCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#6D7B8E",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 5,
    opacity: 0.327,
    cx: 250.244,
    cy: 250,
    rx: 144.43,
    ry: 144.673
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 4,
    opacity: 0.176,
    cx: 250,
    cy: 250,
    r: 248
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTAwcHgiIGhlaWdodD0iNTAwcHgiIHZpZXdCb3g9IjAgMCA1MDAgNTAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA2My4xICg5MjQ1MikgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+R3JvdXAgMyBDb3B5IDI8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iMjAyMV8wMl9Db21wYXJlX0xQIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjQuMDAwMDAwLCAtNDIzNy4wMDAwMDApIiBpZD0iR3JvdXAtMy1Db3B5LTIiIHN0cm9rZT0iIzZEN0I4RSI+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0LjAwMDAwMCwgNDIzNy4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxlbGxpcHNlIGlkPSJPdmFsLUNvcHktNiIgc3Ryb2tlLXdpZHRoPSI1IiBvcGFjaXR5PSIwLjMyNzQyNzQ1NSIgY3g9IjI1MC4yNDM2NjUiIGN5PSIyNTAiIHJ4PSIxNDQuNDI5ODI1IiByeT0iMTQ0LjY3MzQ4OSI+PC9lbGxpcHNlPgogICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbC1Db3B5LTYiIHN0cm9rZS13aWR0aD0iNCIgb3BhY2l0eT0iMC4xNzYwODM1MTkiIGN4PSIyNTAiIGN5PSIyNTAiIHI9IjI0OCI+PC9jaXJjbGU+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgOrbitCircles as ReactComponent };